import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CustomerPortalService {
  ENDPOINT_CHECK_SUBDOMAIN = "/customer-portal-config/subdomain-availability";
  ENDPOINT_CONFIG = "/customer-portal-config";
  ENDPOINT_BRAND = "/open/customer-portal-config/master/";
  ENDPOINT_TOGGLE_PORTAL = "/customer-portal-config/toggle";
  ENDPOINT_FILEUPLOAD = "/attachments/upload";

  constructor(private http: HttpClient) {}

  checkSubdomainAvailability(subDomain: string) {
    let url: string = this.ENDPOINT_CHECK_SUBDOMAIN + `?subDomain=${subDomain}`;

    return this.http.get(environment.base_url + url).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  getPortalConfig() {
    let url: string = this.ENDPOINT_CONFIG;

    return this.http.get(environment.base_url + url).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  getBrandingByDomain(domain: string) {
    let url: string = this.ENDPOINT_BRAND;

    return this.http.get(environment.base_url + url + domain).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  updateCustomerPortalActivationFlag(params: any): Observable<any> {
    let apiUrl: string =
      environment.base_url + this.ENDPOINT_TOGGLE_PORTAL + "?enabled=true";
    let options: any = { observe: "response" };

    return this.http.put(apiUrl, {}, options).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => throwError(() => error)),
    );
  }

  saveConfigData(params: any): Observable<any> {
    //customer-portal-config
    let apiUrl: string = environment.base_url + this.ENDPOINT_CONFIG;
    let options: any = { observe: "response" };

    return this.http.post(apiUrl, params, options).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => throwError(() => error)),
    );
  }

  uploadLogo(formData: any) {
    let url: string = this.ENDPOINT_FILEUPLOAD;
    url = url + `?parentType=CUSTOMER_PORTAL_LOGO`;
    return this.http
      .post(environment.base_url + url, formData, { observe: "response" })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  getImage(url: string): Observable<Blob> {
    return this.http
      .get(url, { responseType: "blob" })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
